//@flow
import * as React from 'react';

type State = {
    isTabVisible: boolean
};
class TabVisibility extends React.PureComponent<
    {
        onChange?: ({ isTabVisible: boolean }) => void,
        onUpdate?: ({ isTabVisible: boolean }) => void,
        children?: ?({
            isTabVisible: boolean
        }) => React.Node
    },
    State
> {
    state = {
        isTabVisible: !document.hidden
    };
    componentDidMount() {
        this.props.onChange?.({
            isTabVisible: !document.hidden
        });
        this.setState({
            isTabVisible: !document.hidden
        });
        document.addEventListener(
            'visibilitychange',
            this.handleVisibilityChange
        );
    }
    componentWillUnmount() {
        document.removeEventListener(
            'visibilitychange',
            this.handleVisibilityChange
        );
    }
    handleVisibilityChange = (event: Event) => {
        this.props.onChange?.({ isTabVisible: !event.target.hidden });
        this.props.onUpdate?.({ isTabVisible: !event.target.hidden });
        this.setState({ isTabVisible: !event.target.hidden });
    };
    render() {
        const { children } = this.props;
        if (!children) {
            return null;
        }
        return children({
            isTabVisible: this.state.isTabVisible
        });
    }
}

export { TabVisibility };
export default TabVisibility;
